class AuthorizationError extends Error {
  reason: number;

  constructor(reason: number) {
    super('Authorization Error');
    this.reason = reason;
  }
}

export default AuthorizationError;
